<template>
  <div class="hab-detail">
    <compTabs
      className="hab-detail-tabs mt-12"
      :dataSource="tabs"
      :active="tabValue"
      @onTabs="onTabs"
    >
      <div class="mt-16">
        <compGallery
          v-show="tabValue === 'GALLERY'"
          :key="galleryList.length"
          :dataSource="galleryList"
          :isLoading="isLoadingGallery"
        />
        <compUtility
          v-show="tabValue === 'UTILITIES'"
          :key="get(dataSource, 'company.id')"
          :operatorId="get(dataSource, 'company.id')"
          :seatTemplateId="get(dataSource, 'route.schedules.0.seat_template_id', null)"
        />
        <compPolicy
          v-show="tabValue === 'POLICY'"
          :key="policyConfigDetail.length || schedules?.refundable"
          :dataSource="policyConfigDetail"
          :schedules="schedules"
          :policyCancellation="policyCancellation"
          :isLoading="isLoadingPolicyConfigDetail"
        />
        <compEvaluate
          v-show="tabValue === 'EVALUATE'"
          :key="get(dataSource, 'company.id')"
          :operatorId="get(dataSource, 'company.id')"
        />
      </div>
    </compTabs>
  </div>
</template>
<script>
import compTabs from "../../tabs";
import compGallery from "./detail/gallery.vue";
import compPolicy from "./detail/policy.vue";
import compEvaluate from "./detail/evaluate.vue";
import compUtility from "./detail/utility.vue";
import { get } from "lodash";

export default {
  components: {
    compTabs,
    compGallery,
    compPolicy,
    compEvaluate,
    compUtility,
  },
  props: {
    dataSource: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      tabs: [
        {
          name: this.$t("detail.hinh_anh"),
          value: "GALLERY",
        },
        {
          name: this.$t("detail.tien_ich"),
          value: "UTILITIES",
        },
        {
          name: this.$t("detail.chinh_sach"),
          value: "POLICY",
        },
        {
          name: this.$t("detail.danh_gia"),
          value: "EVALUATE",
        },
      ],
      tabValue: "GALLERY",
      isLoadingGallery: true,
      isLoadingPolicyConfigDetail: false,
      galleryList: [],
      policyConfigDetail: [],
      policyCancellation: null,
      schedules: null,
    };
  },
  methods: {
    get,
    onTabs(values) {
      this.tabValue = values?.value;
    },
    callGallery() {
      this.$store
        .dispatch("getCompanyImage", {
          id: this.dataSource?.company?.id,
          resource_id: get(this.dataSource, 'route.schedules.0.seat_template_id', null)
        })
        .then((result) => {
          this.isLoadingGallery = false;
          this.galleryList = result?.length ? result : [];
        });
    },
    callPolicyConfigDetail() {
      const schedules = this.dataSource?.route?.schedules?.[0];
      if (!schedules?.refundable) {
        return;
      }

      this.isLoadingPolicyConfigDetail = true;
      this.$store
        .dispatch("getPolicyConfigDetail", {
          trip_code: schedules?.trip_code,
          seat_template_id: schedules?.seat_template_id,
        })
        .then((result) => {
          this.policyConfigDetail = result?.length ? result : [];
          this.isLoadingPolicyConfigDetail = false;
        });
    },
    callPolicyCancellation() {
      const schedules = this.dataSource?.route?.schedules?.[0];
      this.$store
        .dispatch("getPolicyCancellation", {
          trip_code: schedules?.trip_code,
        })
        .then((result) => {
          this.policyCancellation = result;
        });
    },
  },
  mounted() {
    this.schedules = this.dataSource?.route?.schedules?.[0];
    this.callGallery();
    this.callPolicyConfigDetail();
    this.callPolicyCancellation();
  },
};
</script>
